import axios from "axios";
import "../config";

// El servidor genera el HTML del correo a partir del artículo al que pertenece
// el PDF; el front solo indica destinatario y PDF.
export const enviarEmail = async (email, pdf) => {
  const config = {
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
  };

  return await axios
    .post(global.ruta + "/common/sendEmail", { email, pdf }, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
